(() => {
  if (window.__vgFreeShipInit) return;
  window.__vgFreeShipInit = true;

  const isCartLike = (obj) => obj && typeof obj === 'object' && typeof obj.total_price === 'number';

  const formatMoney = (cents, moneyFormat) => {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
      }
    } catch (e) {}
    // fallback (won't be perfect for non-USD, but prevents blank)
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  };

  const updateAll = (cart) => {
    document.querySelectorAll('[data-vg-free-ship]').forEach((wrap) => {
      const threshold = Number(wrap.dataset.thresholdCents || 0);
      const moneyFormat = wrap.dataset.moneyFormat || '${{amount}}';
      if (!threshold || !isCartLike(cart)) return;

      const total = cart.total_price;
      const qualified = total >= threshold;
      const remaining = Math.max(0, threshold - total);
      const pct = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));

      const qualifyRow = wrap.querySelector('[data-vg-free-ship-qualify]');
      const addmoreRow = wrap.querySelector('[data-vg-free-ship-addmore]');
      const remainingEl = wrap.querySelector('[data-vg-free-ship-remaining]');
      const fillEls = wrap.querySelectorAll('[data-vg-free-ship-fill]');
      const usEl = wrap.querySelector('[data-vg-free-ship-us]');

      if (qualifyRow) qualifyRow.style.display = qualified ? '' : 'none';
      if (addmoreRow) addmoreRow.style.display = qualified ? 'none' : '';

      if (remainingEl) remainingEl.textContent = formatMoney(remaining, moneyFormat);

      fillEls.forEach((el) => {
        el.style.width = (qualified ? 100 : pct) + '%';
      });

      // Keep US text consistent if you ever want to change it via dataset
      if (usEl && wrap.dataset.usText) usEl.textContent = wrap.dataset.usText;
    });
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  };

  // Hook fetch: when theme calls /cart/change.js or /cart/update.js we instantly update from returned cart JSON
  const origFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await origFetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (url.includes('/cart/change') || url.includes('/cart/update') || url.endsWith('/cart.js') || url.includes('/cart.js')) {
        const clone = res.clone();
        clone.json()
          .then((data) => {
            if (isCartLike(data)) updateAll(data);
          })
          .catch(() => {});
      } else if (url.includes('/cart/add')) {
        // add.js often returns line-item, not full cart -> fetch cart for accuracy
        fetchCart().then(updateAll).catch(() => {});
      }
    } catch (e) {}

    return res;
  };

  // Hook XHR too (some themes use XHR instead of fetch)
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__vg_url = url;
    return origOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      try {
        const url = this.__vg_url || '';
        if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart.js')) {
          const data = JSON.parse(this.responseText);
          if (isCartLike(data)) updateAll(data);
        } else if (url.includes('/cart/add')) {
          fetchCart().then(updateAll).catch(() => {});
        }
      } catch (e) {}
    });
    return origSend.apply(this, args);
  };

  // Initial sync (drawer open/first load)
  document.addEventListener('DOMContentLoaded', () => {
    fetchCart().then(updateAll).catch(() => {});
  });

  // Safety net: if DOM is re-rendered by sections, re-sync once quickly
  let t;
  const obs = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => {
      fetchCart().then(updateAll).catch(() => {});
    }, 120);
  });
  obs.observe(document.documentElement, { subtree: true, childList: true });
})();